<template>
<div v-if="deviceId">  
  <div v-if="device.parent_device_id">
    <div class="form-group" style="position:relative">
      <label for="pairstrategyselect">Pairing Options</label>
      <select class="form-control custom-select" id="pairstrategyselect" @change="updatePairingStrategy($event.target.value)" :value="pairingStrategy">
        <option disabled value='null'>No strategy selected</option>
        <option v-for="(text, key) in pairingStrategies" :value='key' :key='key'>{{text}}</option>
      </select>
    </div>
  </div>
</div>


</template>

<script >
export default {
  data: function() {
    return {
      pairingStrategies: {
        ringafter:'Ring after main phone',
        noring:'Do not ring mobile',
        ringonly:'Only ring mobile (skip desk phone)',
        dnd:'Do not ring any phones',
      },
    }
  },
  methods: {
    updatePairingStrategy: function(strategy) {
      this.device.pairing_strategy = strategy;
      this.$store.dispatch('updateDevice', this.device);
    },
  },
  computed: {
    deviceId: { get: function() { return this.$store.state.deviceId } },
    device: { get: function() { return this.$store.state.device }},
    pairingStrategy: { get: function() {
      if (this.device) {
        return this.device.pairing_strategy;
      }
      return null;
    }},
  },
}
</script>
